import { createPreferencesService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const PreferencesService = createPreferencesService(authorizedHttpClient, import.meta.env.VITE_API_URL)
